import { EmissionPointsWithParametersView } from '../../../_generated';
import { EmissionPointsAction, EmissionPointsActionType } from '../../actionstypes/emission-points/emission-points.actiontype';

const initialState: EmissionPointsWithParametersView[] = [];

export default (state = initialState, action: EmissionPointsActionType): EmissionPointsWithParametersView[] => {
  switch (action.type) {
    case EmissionPointsAction.Get:
      return action.payload;

    case EmissionPointsAction.Reset:
      return [];

    default:
      return state;
  }
};
